export interface PracticeLocation {
  shareId: string | null
  ownerSongId: number | null
  albumToken: string | null
  albumSong: string | null
  noticeCode: string | null
}

const NORMALIZED_NOTICE_CODE = /^[A-Z][A-Z0-9_]{1,63}$/

function normalizedNoticeCode(value: string | null): string | null {
  if (!value) return null
  const normalized = value.trim().toUpperCase()
  return NORMALIZED_NOTICE_CODE.test(normalized) ? normalized : null
}

function decodePart(value: string | undefined): string | null {
  if (!value) return null
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export function parsePracticeLocation(pathname: string, search: string): PracticeLocation {
  const parts = pathname.split('/').filter(Boolean)
  const query = new URLSearchParams(search)
  const noticeCode = normalizedNoticeCode(query.get('notice'))

  if (noticeCode) {
    return {
      shareId: null,
      ownerSongId: null,
      albumToken: null,
      albumSong: null,
      noticeCode,
    }
  }

  if (parts.length === 2 && parts[0] === 's') {
    return {
      shareId: decodePart(parts[1]),
      ownerSongId: null,
      albumToken: null,
      albumSong: null,
      noticeCode: null,
    }
  }

  if (parts.length === 2 && parts[0] === 'a') {
    return {
      shareId: null,
      ownerSongId: null,
      albumToken: decodePart(parts[1]),
      albumSong: query.get('song'),
      noticeCode: null,
    }
  }

  const albumToken = query.get('album')
  const ownerSongValue = query.get('mine')
  const parsedOwnerSongId = ownerSongValue == null ? null : Number(ownerSongValue)
  const ownerSongId = parsedOwnerSongId != null && Number.isInteger(parsedOwnerSongId) && parsedOwnerSongId > 0 ? parsedOwnerSongId : null
  return {
    shareId: albumToken || ownerSongId != null ? null : query.get('id'),
    ownerSongId,
    albumToken,
    albumSong: query.get('song'),
    noticeCode: null,
  }
}

export function songPracticePath(shareId: string): string {
  return `/s/${encodeURIComponent(shareId)}`
}

export function albumPracticePath(albumToken: string, shareId?: string | null): string {
  const path = `/a/${encodeURIComponent(albumToken)}`
  if (!shareId) return path
  const query = new URLSearchParams({ song: shareId })
  return `${path}?${query.toString()}`
}

export function ownerPracticePath(songId: number): string {
  const query = new URLSearchParams({ mine: String(songId) })
  return `/?${query.toString()}`
}
